module.exports = "//public.zight.com/packs/media/images/markers/m_3-404f3986e902dd0770dc7111656c9734.svg";